import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager" */ "/app/public/assets/images/homes-logo.png");
;
import(/* webpackMode: "eager" */ "/app/public/assets/images/innovation-logo.png");
;
import(/* webpackMode: "eager" */ "/app/public/assets/images/jobs-logo.png");
;
import(/* webpackMode: "eager" */ "/app/public/assets/images/ravo-logo.png");
